import types from './actionTypes';

const initialState = {
  loading: false,
  customers: [],
  error: '',
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_CUSTOMER_STATE:
      return initialState;
    case types.CREATE_CUSTOMER.REQUEST:
    case types.UPDATE_CUSTOMER.REQUEST:
    case types.SYNC_CUSTOMERS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.CREATE_CUSTOMER.SUCCESS:
    case types.UPDATE_CUSTOMER.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case types.SYNC_CUSTOMERS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        customers: [...action.customers],
      };
    case types.CREATE_CUSTOMER.FAILURE:
    case types.UPDATE_CUSTOMER.FAILURE:
    case types.SYNC_CUSTOMERS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default customerReducer;
